import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import UploadImage from '../../assets/images/bill.gif';
import FileUploadSchema from './schema';
import request from '../utils/request';
import ValidateLoader from '../UI/validateLoader';
import MessageDialog from './messageDialog';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const BulkUpload = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [isResponse, setResponse] = useState(null);
  const localizedStrings = useLocalizedStringsContext();
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const {
    role: { name }
  } = userProfile;

  useEffect(() => {
    if (name !== 'ADMIN') {
      history.push('/orders');
    }
  }, [userProfile.role.name]);
  const uploadFile = value => {
    setError(false);
    setLoading(true);

    const data = new FormData();
    data.append('registrationFile', value.registrationFile);
    request
      .post(`/users/upload`, data)
      .then(response => {
        setResponse(response && response.data);
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const validateFile = (e, setFieldValue) => {
    const event = e;
    const file = event.target.files[0];
    if (file.type.includes('spreadsheetml') || file.type.includes('.excel')) {
      setFieldValue('registrationFile', file);
    } else {
      event.target.value = '';
    }
  };

  const onCloseModal = () => {
    setSuccess(false);
  };
  const {
    USERS: {
      BULK_FILE_UPLOAD: {
        TITLE,
        BUTTON_TITLE,
        LOADING_MESSAGE,
        FILE_ACCEPTED_MESSAGE,
        ERRORS_MESSAGES: { FILE_TYPE }
      }
    }
  } = localizedStrings;
  return (
    <>
      <div id="main" style={{ marginBottom: '12%' }}>
        <div id="main-wrapper">
          <div id="main-content">
            <div id="main-content-form">
              <div
                id="main-content-form-devices"
                className="main-content-form-block"
                style={{ position: 'relative' }}
              >
                <h3>
                  <div
                    className="main-content-form-title"
                    style={{ position: 'relative' }}
                  >
                    {TITLE}
                  </div>
                </h3>
                <div
                  style={{
                    padding: 10,
                    backgroundColor: '#f5f6f7',
                    borderBottom: 'solid 1px',
                    borderBottomColor: '#e2e2e2'
                  }}
                >
                  {loading && <ValidateLoader message={LOADING_MESSAGE} />}
                  {isSuccess && (
                    <MessageDialog
                      responseObj={isResponse}
                      message={FILE_ACCEPTED_MESSAGE}
                      isClose={() => onCloseModal()}
                    />
                  )}

                  <div>
                    <div
                      id="wireless_compliance_error_screenshot_main_container"
                      className="main-content-form-content"
                      style={{ marginTop: 25 }}
                    >
                      <div id="fibre_internet_porting_content">
                        <div style={{ marginTop: 15 }}>
                          <div
                            id="wireless_compliance_error_screenshot_container"
                            style={{ marginBottom: 15 }}
                          >
                            <div style={{ display: 'inline-block' }}>
                              <div
                                style={{
                                  display: 'inline-block',
                                  margin: '0px 15px 0px 0px',
                                  verticalAlign: 'top'
                                }}
                              >
                                <div>
                                  <div
                                    id="bill_sample"
                                    style={{
                                      border: 'solid 1px',
                                      borderColor: '#cccccc',
                                      display: 'inline-block',
                                      margin: '0px 5px 0px 0px',
                                      verticalAlign: 'top'
                                    }}
                                  >
                                    <img
                                      src={UploadImage}
                                      width={100}
                                      height={100}
                                      alt="upload-file"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'inline-block',
                                  verticalAlign: 'top'
                                }}
                              >
                                <div>
                                  <Formik
                                    initialValues={{
                                      registrationFile: ''
                                    }}
                                    validationSchema={FileUploadSchema}
                                    onSubmit={values => {
                                      uploadFile(values);
                                    }}
                                  >
                                    {({ errors, setFieldValue }) => (
                                      <Form encType="multipart/form-data">
                                        <div>
                                          <span className="frg-body-font-14px">
                                            <input
                                              type="file"
                                              id="device_batch_upload"
                                              name="registrationFile"
                                              accept=".xls, .xlsx"
                                              onChange={event => {
                                                validateFile(
                                                  event,
                                                  setFieldValue
                                                );
                                              }}
                                            />
                                          </span>
                                        </div>
                                        <div
                                          style={{ width: 150, marginTop: 10 }}
                                        >
                                          <span>
                                            <button
                                              type="submit"
                                              className="frg-button color-purple"
                                            >
                                              {BUTTON_TITLE}
                                            </button>
                                          </span>
                                        </div>

                                        {errors && errors.registrationFile && (
                                          <div style={{ color: 'red' }}>
                                            <span className="frg-body-font-14px">
                                              {errors.registrationFile}
                                            </span>
                                          </div>
                                        )}
                                        {isError && (
                                          <div style={{ color: 'red' }}>
                                            <span className="frg-body-font-14px">
                                              {FILE_TYPE}
                                            </span>
                                          </div>
                                        )}
                                      </Form>
                                    )}
                                  </Formik>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

BulkUpload.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default BulkUpload;
